/**
 * Professional Scroll-Reveal Animation Worklet
 * 
 * Handles declarative entry animations (fade, slide, scale) linked exactly
 * to the scroll intersection progress.
 */

class ScrollRevealAnimator {
  animate(currentTime: number, effect: any) {
    // currentTime represents the progress of the scroll timeline (0 to 100 typically)
    const progress = currentTime / 100;
    
    // We can compute complex easing or multi-step reveals here
    // For a professional reveal, we might want a sharp entry then a slow settle
    const easedProgress = Math.min(1, progress * 1.5);
    
    effect.localTime = easedProgress * 1000; // Map progress to milliseconds for the keyed effect
  }
}

registerAnimator('fluent-scroll-reveal', ScrollRevealAnimator);
